import { type FC, type ReactNode, useState, useCallback } from 'react';
import { graphql, useFragment } from 'react-relay';
import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { BuyerIncentivesBanner } from 'dibs-buyer-incentives/exports/BuyerIncentivesBanner.ts';
import { PdpSharedDibsPromiseModalLazy } from '../../PdpSharedModals/PdpSharedDibsPromiseModal/PdpSharedDibsPromiseModalLazy.tsx';

import { type PdpSharedSidebarBuyerIncentives_user$key } from './__generated__/PdpSharedSidebarBuyerIncentives_user.graphql.ts';

const userFragment = graphql`
    fragment PdpSharedSidebarBuyerIncentives_user on User {
        ...PdpSharedDibsPromiseModalLazy_user
    }
`;

const PdpSharedSidebarBuyerIncentives: FC<{
    user?: PdpSharedSidebarBuyerIncentives_user$key | null | undefined;
    isPDPDesktopAggregationVariant?: boolean;
}> = ({ user: userRef, isPDPDesktopAggregationVariant = false }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const user = useFragment(userFragment, userRef);

    const handleOpenModal = useCallback(() => {
        setIsModalOpen(true);
        trackEvent({
            eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
            interaction_type: interactionTypeConstants.INTERACTION_TYPE_EBI_DETAILS,
            step_interaction_name:
                stepInteractionConstants.STEP_INTERACTION_EBI_SIDERAIL_DETAILS_CLICK,
        });
    }, []);

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    const getLink = (chunk: ReactNode): ReactNode => {
        return (
            <Link dataTn="dibs-promise-link" href="#" onClick={handleOpenModal}>
                {chunk}
            </Link>
        );
    };
    return (
        <>
            <BuyerIncentivesBanner
                linkPosition={isPDPDesktopAggregationVariant ? 'top' : 'bottom'}
                getLink={getLink}
            />
            <PdpSharedDibsPromiseModalLazy
                user={user}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
};

export default PdpSharedSidebarBuyerIncentives;
